module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("IV "), _c('em', [_vm._v("The Boomerang Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The Boomerang Effect is expressed in the traditional occult maxim: ‘Any psychic attack which comes up against a stronger defence rebounds threefold on the attacker.’")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("‘Threefold’ may sound rather more metaphorical than precise – how would you measure the rebound? – but taking it to mean ‘with even greater effect’, we have certainly found it to be true; and it is one of the greatest practical (in addition to the ethical) reasons for refraining from malevolent magic. Morality apart, not even the most powerful black magician can be sure that he will never encounter that stronger defence; which is why black magic is always, in the end, self-destructive.")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("‘A stronger defence’ can mean three things. First, of course, conscious and deliberate defence when you are aware of the attack. Second, the habit of keeping yourself permanently in a state of defence. And third, a naturally tough psychic skin – which many people, even without any occult knowledge or even a belief in psychism, do possess.")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("A balance should always be kept between the first and second aspects. A round-the-clock obsession with psychic defence can amount to paranoia and divert energy and attention from positive matters. The best attitude to develop is one of calm confidence and of improving your psychic awareness, so that you will always know pretty quickly if an attack is on the way. The improving of psychic awareness and sensitivity is a central aim of Craft practice – and it should be seen as an all-round development, for sensitivity to positive phenomena and opportunities and to the needs of others, not merely to threats.")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("We shall go into the subject of psychic self-defence in the "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("next chapter")]), _vm._v(", but we will emphasize here that the answer to psychic attack should never be counter-attack, which is fraught with danger; it should be reliance on the Boomerang Effect by strengthening your own defences and, if necessary, a binding spell, which we explain in "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c19.htm"
    }
  }, [_vm._v("Chapter XIX")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("Valerie Worth ("), _c('em', [_vm._v("The Crone’s Book of Words")]), _vm._v(", p. 98) gives a spell for breaking a curse so that it returns to its source. You collect four fallen twigs – one each of hazel, oak, elm and willow – and hold them in the smoke of a fire while you repeat seven times:")]), _vm._v(" "), _c('div', {
    staticClass: "block5"
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Turner be turned,")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Burner be burned:")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Let only good")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Come of this wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("You then spit on each twig, break it small and throw them in the fire. ‘The curse will die with the fire’s death.’")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("After so much discussion of principles, this is the first spell we have quoted which involves what the rationalist would call ‘mumbo-jumbo’. Why the four twigs, why specifically those four trees and why the spitting and the burning?")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("We shall be quoting dozens more of such spells, particularly in "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("Chapters XI")]), _vm._v("-"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_vm._v("XIV")]), _vm._v(". The formulae, actions and objects or substances they involve may have many different purposes. Sometimes they may be, frankly, just to impress the uninitiated. Sometimes they may be a distorted memory of something which originally had a physically, psychologically or psychically practical reason. And even oftener they may be calling upon a symbolism, whether conscious or unconscious, which aids the inter-level communication we spoke of in "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("II Why and How")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("What one should not do is to dismiss them out of hand just because the reason for their form is not immediately obvious to rational analysis. You may find that they work though you don’t know why – that the power of their symbology is buried too deeply in your personal Unconscious (or even in the Collective Unconscious) for your conscious awareness to find it.")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("A traditional spell is often rather like poetry, in that the power can manifest even though the reasons for its working remain a mystery.")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("It is best to keep a cautiously open mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("Susa Morgan Black sends us another way of ensuring the Boomerang Effect and deflecting bad energy back to the sender, the symbology of which is more apparent.")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("‘Take a special hand-held mirror,’ she says, ‘and simply turn completely around with the mirror reflecting outward and state an affirmation like –")]), _vm._v(" "), _c('div', {
    staticClass: "block5"
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("‘Circle of Reflection,")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Circle of Protection,")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("May the sender of all harm")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Feel the power of this charm.’")])]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("We have used mirrors for this purpose ourselves when we have known who was working against us, and in what direction he or she lived. We would put a mirror in a suitable window facing outwards in that direction, willing it to send the malevolence back to its source.")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_vm._v("But such working really leads us into the "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("next chapter")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-428d8fc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c04.vue
// module id = 81
// module chunks = 0